import * as uuid from 'uuid';

import BpkText, {
  TEXT_COLORS,
  TEXT_STYLES,
} from '@skyscanner/backpack-web/bpk-component-text';

import ReviewImageGallery from '../ReviewImageGallery';
import ReviewParagraphs from '../ReviewParagraphs';

import type { Reply } from '@shared/types/frontend/ubff/hotel-reviews';
import type { I18nService } from '@shared/types/i18n';

import STYLES from './ReviewReplies.module.scss';

import TranslationContent from '@shared/ui/components/Translation/TranslationContent';
import { withI18n } from '@shared/ui/contexts/i18n';

type Props = {
  i18n: I18nService;
  replies: Reply[];
  isPending?: boolean;
  limit?: number;
};

const ReviewReplies = ({ i18n, isPending, limit, replies }: Props) =>
  replies?.length ? (
    <div className={STYLES.ReviewReplies__bubble}>
      <div className={STYLES.ReviewReplies__replies}>
        {replies.map(({ date, images, text, travellerSource }, index) => (
          <div className={STYLES.ReviewReplies__reply} key={`${uuid.v4()}`}>
            <div className={STYLES.ReviewReplies__titleAndDate}>
              <BpkText
                tagName="p"
                textStyle={TEXT_STYLES.label1}
                className={STYLES.ReviewReplies__replyType}
                color={TEXT_COLORS.textPrimary}
              >
                {travellerSource
                  ? i18n.translate('Reviews_TravellerResponse')
                  : i18n.translate('Reviews_HotelResponse')}
              </BpkText>
              <BpkText
                textStyle={TEXT_STYLES.caption}
                tagName="p"
                className={STYLES.ReviewReplies__replyDate}
                color={TEXT_COLORS.textSecondary}
              >
                {date}
              </BpkText>
            </div>
            <div className={STYLES.ReviewReplies__replyContent}>
              <TranslationContent isPending={isPending}>
                <ReviewParagraphs
                  review={text}
                  className={STYLES.ReviewReplies__replyContentOptimization}
                  limit={limit}
                />
              </TranslationContent>
            </div>
            {!!images?.length && (
              <ReviewImageGallery
                images={images.map(({ url }) => ({ src: url }))}
                reviewIndex={index}
              />
            )}
          </div>
        ))}
      </div>
    </div>
  ) : null;

export default withI18n(ReviewReplies);
